export default {
    listagem: {
        titulo_pagina: 'Lista de Complementos',
        novo: 'Crear Nuevo Complemento',
        habilitado: 'Capaz',
        desabilitado: 'Desactivado',
        table: {
            empty: 'No se encontraron complementos',
            nome: 'Nombre',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Complemento',
            editar: 'Editar Complemento'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código del Complemento'
            },
            nome: {
                label: 'Nombre',
                description: 'Nombre del Complemento'
            },
            status: {
                label: 'Estado',
                description: 'Estado del complemento activo o inactivo'
            },
            botao_salvar : 'Guardar Complemento'
        },
        create: {
            success: '¡Complemento creado con éxito!',
            error: '¡Error al crear el complemento!'
        },
        update: {
            success: '¡Complemento editado con éxito!',
            error: '¡Error al editar el complemento!'
        }
    }
}
